import React, { useState } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import Stack from '@mui/material/Stack'
import TPPCellCard from '../../../views/TPP/components/TPPCell/TPPCell'
import { TppCell as TppCellType, TppColumn, DRAG_TYPES } from '../types'

interface TppCellProps {
    cell: TppCellType
    isSlotHovered?: boolean
    isSummary: boolean
    visibleColumns: { id: string; label: string }[]
    columnsById: Record<string, TppColumn>
    cellsById: Record<string, TppCellType>
    occupiedColumnIds: string[]
    slotDragAttributes: Record<string, any>
    slotDragListeners: Record<string, any>
    isMovePending?: boolean
    canEdit?: boolean
}

const TppCell: React.FC<TppCellProps> = ({
    cell,
    isSlotHovered,
    isSummary,
    visibleColumns,
    columnsById,
    cellsById,
    occupiedColumnIds,
    slotDragAttributes,
    slotDragListeners,
    isMovePending,
    canEdit = true,
}) => {
    const [isEditing, setIsEditing] = useState(false)
    const isCloneRelated = cell?.isClone || (Array.isArray(cell?.childClones) && cell.childClones.length > 0)
    const isColumnLocked = !!columnsById?.[cell.columnId]?.locked
    const isColumnArchived = !!columnsById?.[cell.columnId]?.archived
    const { attributes, listeners, setNodeRef, transform, isDragging } = useSortable({
        id: cell._id,
        disabled: isCloneRelated || isMovePending || isColumnLocked || isColumnArchived || isEditing || !canEdit,
        data: {
            type: DRAG_TYPES.CELL,
            cellId: cell._id,
            slotId: cell.slotId,
            columnId: cell.columnId,
            content: cell.content,
        },
    })

    const isDraggable = !isMovePending && !isColumnLocked && !isColumnArchived && !isEditing && canEdit
    const style = {
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0 : 1,
        cursor: isMovePending ? 'progress' : isDraggable ? 'grab' : 'default',
        width: '100%',
    }

    return (
        <Stack
            direction="row"
            ref={setNodeRef}
            {...(!isCloneRelated ? attributes : slotDragAttributes)}
            {...(!isCloneRelated ? listeners : slotDragListeners)}
            style={style}
        >
            <TPPCellCard
                cell={cell}
                dispatch={() => {}}
                isSlotHovered={isSlotHovered}
                visibleColumns={visibleColumns}
                columnsById={columnsById}
                cellsById={cellsById}
                occupiedColumnIds={occupiedColumnIds}
                isMovePending={isMovePending}
                onEditingChange={setIsEditing}
                canEdit={canEdit}
            />
        </Stack>
    )
}

export default TppCell
